import EducationYearSelector from './EducationYearSelector';

export default EducationYearSelector;
